export const OTP_LENGTH = 6;

export const OTP_EXPIRES_IN = 10 * 60;

export const LOGIN_STEPS = Object.freeze({
  ENTER_EMAIL: Symbol('enter_email'),
  VERIFY_OTP: Symbol('verify_email_via_otp'),
  LOGIN_ERROR: Symbol('login_error'),
  COMPLETE_PROFILE: Symbol('complete_profile'),
  INVITE_EXPIRED_ERROR: Symbol('invite_expired_error'),
});
